export default __webpack_public_path__ + "static/media/playButton.eeb54a03.svg";